var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoDetalle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.38 28.12",
    style: {
      enableBackground: "new 0 0 21.38 28.12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7367F0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3599",
    className: "st0",
    d: "M14.62,6.96h6.4c0.19,0,0.35-0.15,0.35-0.34c0,0,0-0.01,0-0.01l0,0 c0-0.62-0.27-1.21-0.75-1.61l-5.37-4.47c-0.41-0.34-0.92-0.52-1.45-0.52l0,0c-0.29,0-0.52,0.23-0.52,0.52c0,0,0,0,0,0v5.1 C13.29,6.36,13.89,6.96,14.62,6.96C14.62,6.96,14.62,6.96,14.62,6.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3600",
    className: "st0",
    d: "M11.46,5.62V0H2.25C1.01,0,0,1.01,0,2.25v23.62c0,1.24,1.01,2.25,2.25,2.25h16.88 c1.24,0,2.25-1.01,2.25-2.25V8.79h-6.75C12.88,8.79,11.46,7.37,11.46,5.62z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDetalle);
export default __webpack_public_path__ + "static/media/icono-detalle.c2c0c8b026e44733bfdbacf3b545fb64.svg";
export { ForwardRef as ReactComponent };